'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react';
import { useLayoutEffect, useState } from 'react';
const PADDING_X = 8;
const PADDING_Y = 7.5;
interface CutoutPosition {
  top: number;
  bottom: number;
  left: number;
  right: number;
  width: number;
  height: number;
}
export function SiteSelectorWithPopoverBackdrop() {
  const $ = _c(4);
  const [cutout, setCutout] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const el = document.getElementById("site-toggle-highlight");
      if (!el) {
        return;
      }
      const measure = () => {
        const rect = el.getBoundingClientRect();
        setCutout({
          top: rect.top - PADDING_Y,
          bottom: rect.bottom + PADDING_Y,
          left: rect.left - PADDING_X,
          right: rect.right + PADDING_X,
          width: rect.width + PADDING_X * 2,
          height: rect.height + PADDING_Y * 2
        });
      };
      measure();
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(el);
      window.addEventListener("resize", measure);
      return () => {
        resizeObserver.disconnect();
        window.removeEventListener("resize", measure);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  const t2 = cutout ? `polygon(evenodd, ${getClipPath(cutout)})` : undefined;
  let t3;
  if ($[2] !== t2) {
    t3 = <Popover.Backdrop className="fixed inset-0 min-h-dvh bg-black opacity-20 dark:opacity-70 transition-[clip-path,opacity] duration-150 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0 supports-[-webkit-touch-callout:none]:absolute" style={{
      clipPath: t2
    }} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function getClipPath({
  top,
  bottom,
  left,
  right
}: CutoutPosition) {
  return ['0px 0px', '100% 0px', '100% 100%', '0px 100%', `0px ${top}px`, `${left}px ${top}px`, `${left}px ${bottom}px`, `${right}px ${bottom}px`, `${right}px ${top}px`, `0px ${top}px`].join(', ');
}